module.exports = __webpack_public_path__ + "images/linkedIn-learning.jpg";